import { Routes } from '@angular/router';
import { RegisterComponent } from 'src/core/components/auth/register/register.component';
import { ForgotPasswordComponent } from '../../components/auth/forgot-password/forgot-password.component';
import { LoginComponent } from '../../components/auth/login/login.component';
import { ResetPasswordComponent } from '../../components/auth/reset-password/reset-password.component';
import { VerifyRegistrationComponent } from '../../components/auth/verify-registration/verify-registration.component';
import { authRoutesNames } from './auth.routes.names';

export const authRoutes: Routes = [
  {
    path: authRoutesNames.LOGIN,
    component: LoginComponent,
  },
  {
    path: authRoutesNames.LOGOUT,
    redirectTo: authRoutesNames.LOGIN,
  },
  {
    path: authRoutesNames.REGISTER,
    component: RegisterComponent,
  },
  {
    path: authRoutesNames.VERIFY,
    component: VerifyRegistrationComponent,
  },
  {
    path: authRoutesNames.FORGOT_PASSWORD,
    component: ForgotPasswordComponent,
  },
  {
    path: authRoutesNames.RESET_PASSWORD,
    component: ResetPasswordComponent,
  },
  {
    path: '**',
    redirectTo: authRoutesNames.LOGIN,
  },
];
